// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_wrap {
  padding: 20px;
  padding-top: 0;
  margin-bottom: 30vh;
}

form {
  width: 100%;
  background: #fff3e4;
}

ion-header ion-toolbar {
  padding: 10px !important;
}

input {
  min-width: 100%;
  border-radius: 6px;
  border: none;
  background: #fff3e4;
  text-align: left;
  padding: 10px !important;
  border: 1px solid #dbb49f;
}

ion-input,
ion-intl-tel-input {
  border: 1px solid #dbb49f;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 2px !important;
  padding-left: 10px !important;
}

ion-item {
  --border-color: #fff3e4;
}

.hayah {
  margin-top: 2vh;
  display: block;
  font-size: 82px;
  margin-left: 5vw;
  margin-right: 5vw;
  margin-bottom: 5vh;
}

.hyahtext {
  font-size: 10px;
}

.no_seller_acc {
  width: 80%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20vh;
  color: #ab8774;
}
.no_seller_acc p {
  font-size: 16px;
  text-align: center;
  color: #ab8774;
  text-shadow: 1px 1px rgba(255, 255, 255, 0.4);
  margin-top: 20%;
  margin-top: 20vh;
  font-weight: bold;
}

.brown_btn {
  padding: 20px;
  margin-top: 25px;
  background: #dbb49f;
  border: none;
  color: #fff;
  width: 100%;
  font-weight: bold;
  text-transform: uppercase;
  display: block;
  font-size: 12px;
  border-radius: 3px;
}

.hollow {
  margin-top: 10px;
  background: #fff3e4;
  color: #dbb49f;
}

ion-label {
  color: #ab8774 !important;
}

ion-input,
ion-textarea,
input::-webkit-input-placeholder {
  color: #dbb49f;
}

ion-input,
ion-textarea,
input {
  color: #866858;
}

.fake_item {
  background: #fff3e4;
  width: 100%;
  --background: #fff3e4;
  --wheel-highlight-background: #dbb49f2c;
}
.fake_item ion-label {
  margin-left: 20px;
  padding-top: 20px;
}
.fake_item ion-datetime {
  background: #fff3e4;
  margin-left: auto;
  margin-right: auto;
  color: #dbb49f;
}
.fake_item ion-datetime ::part(wheel-item) {
  color: #fff3e4;
}`, "",{"version":3,"sources":["webpack://./src/app/components/seller-register/seller-register.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;AACJ;;AAEA;;EAEI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;AACI;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACR;;AAGA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;;;EAGI,cAAA;AAAJ;;AAGA;;;EAGI,cAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,WAAA;EAEA,qBAAA;EACA,uCAAA;AADJ;AAGI;EACI,iBAAA;EACA,iBAAA;AADR;AAII;EACI,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAFR;AAIQ;EACI,cAAA;AAFZ","sourcesContent":[".form_wrap {\n    padding: 20px;\n    padding-top: 0;\n    margin-bottom: 30vh;\n}\n\nform {\n    width: 100%;\n    background: #fff3e4;\n}\n\nion-header ion-toolbar {\n    padding: 10px !important;\n}\n\ninput {\n    min-width: 100%;\n    border-radius: 6px;\n    border: none;\n    background: #fff3e4;\n    text-align: left;\n    padding: 10px !important;\n    border: 1px solid #dbb49f;\n}\n\nion-input,\nion-intl-tel-input {\n    border: 1px solid #dbb49f;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    padding: 2px !important;\n    padding-left: 10px !important;\n}\n\nion-item {\n    --border-color: #fff3e4;\n}\n\n.hayah {\n    margin-top: 2vh;\n    display: block;\n    font-size: 82px;\n    margin-left: 5vw;\n    margin-right: 5vw;\n    margin-bottom: 5vh;\n}\n\n.hyahtext {\n    font-size: 10px;\n}\n\n.no_seller_acc {\n    width: 80%;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 20vh;\n    color: #ab8774;\n\n    p {\n        font-size: 16px;\n        text-align: center;\n        color: #ab8774;\n        text-shadow: 1px 1px rgb(255 255 255 / 40%);\n        margin-top: 20%;\n        margin-top: 20vh;\n        font-weight: bold;\n    }\n}\n\n.brown_btn {\n    padding: 20px;\n    margin-top: 25px;\n    background: #dbb49f;\n    border: none;\n    color: #fff;\n    width: 100%;\n    font-weight: bold;\n    text-transform: uppercase;\n    display: block;\n    font-size: 12px;\n    border-radius: 3px;\n}\n\n.hollow {\n    margin-top: 10px;\n    background: #fff3e4;\n    color: #dbb49f;\n}\n\nion-label {\n    color: #ab8774 !important;\n}\n\nion-input,\nion-textarea,\ninput::-webkit-input-placeholder {\n    color: #dbb49f;\n}\n\nion-input,\nion-textarea,\ninput {\n    color: #866858;\n}\n\n.fake_item {\n    background: #fff3e4;\n    width: 100%;\n\n    --background: #fff3e4;\n    --wheel-highlight-background: #dbb49f2c;\n\n    ion-label {\n        margin-left: 20px;\n        padding-top: 20px;\n    }\n\n    ion-datetime {\n        background: #fff3e4;\n        margin-left: auto;\n        margin-right: auto;\n        color: #dbb49f;\n\n        ::part(wheel-item) {\n            color: #fff3e4;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
